function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import StyledScreenReaderOnly from './ScreenReaderOnly.style';
import { getCleanProps } from '../../../utility/getCleanProps';
ScreenReaderOnly.propTypes = {
  /** renders the right color on a dark background */
  children: PropTypes.node,

  /** id for the text component */
  id: PropTypes.string,

  /** element to render to */
  as: PropTypes.string,

  /** ref to the screen reader element */
  textRef: PropTypes.shape({
    current: PropTypes.any
  }),

  /** for attribute, when used with a label render */
  htmlFor: PropTypes.string
};
ScreenReaderOnly.defaultProps = {
  as: 'span'
};
export function ScreenReaderOnly(_ref) {
  var children = _ref.children,
      id = _ref.id,
      as = _ref.as,
      htmlFor = _ref.htmlFor,
      textRef = _ref.textRef,
      restProps = _objectWithoutProperties(_ref, ["children", "id", "as", "htmlFor", "textRef"]);

  return /*#__PURE__*/React.createElement(StyledScreenReaderOnly, _extends({}, getCleanProps(restProps), {
    id: id,
    as: as,
    htmlFor: htmlFor,
    ref: textRef
  }), children);
}